import PropTypes from 'prop-types';

// Components
import Icon from '@/components/base/Icon';
import { TooltipPlanRestriction } from '@/components/layouts/LayoutPlatform/components/Menu/components/TooltipPlanRestriction';

const FilterSectionTitle = ({ icon, children, isLocked = false }) => {
    return (
        <div className="mb-4 flex items-center gap-2 text-xs dark:text-white">
            <Icon icon={icon} className="text-sm text-icoBlue" />
            {children}
            {isLocked && (
                <TooltipPlanRestriction position="top">
                    <Icon icon="crown" className="text-icoBlue" />
                </TooltipPlanRestriction>
            )}
        </div>
    );
};

FilterSectionTitle.propTypes = {
    icon: PropTypes.string,
    isLocked: PropTypes.bool,
    children: PropTypes.node.isRequired
};

export default FilterSectionTitle;
